import { Outlet, useNavigation } from "react-router-dom";
import { useState, useEffect, Suspense } from "react";
import {
  faDashboard,
  faGears,
  faHome,
  faUser,
  faMoneyBill,
  faPlus,
  faBasketShopping,
  faBriefcase,
  faBoxesAlt,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import Dashboard from "../../components/Dashboard/Main";
import Cart from "../../components/Cart/Cart";
import { notificationService } from "../../services";
import Spinner from "../../components/UI/Spinner";
import ScrollToTop from "../../hooks/ScrollToTop";
const userDashboard = (props) => {
  const [notificationsCount, setNotificationsCount] = useState(0);
  const navigation = useNavigation();

  const isHome = location.pathname === "/"; // ✅ detect home page
  const isLoading = navigation.state === "loading"; // ✅ detect loader in progress

  useEffect(() => {
    async function getNewNotifications() {
      try {
        const count = await notificationService.newNotificationCounter();
        setNotificationsCount(count);
      } catch (err) {
        console.error(err);
      }
    }
    getNewNotifications();
  }, []);
  const links = [
    {
      name: "Home",
      url: "/user/my-dashboard",
      icon: faDashboard,
    },
    {
      name: "Assets",
      url: "#",
      icon: faBriefcase,
      subLinks: [
        { name: "All", url: "assets/all" },
        { name: "Available", url: "assets/available" },
        { name: "Featured", url: "assets/featured" },
        { name: "Sold", url: "assets/sold" },
      ],
    },
    {
      name: "Purchases",
      url: "#",
      icon: faBasketShopping,
      subLinks: [
        { name: "All", url: "purchases/all" },
        { name: "Uncomfirm", url: "purchases/uncomfirm" },
        { name: "Credentialed", url: "purchases/credentialed" },
        { name: "Comfirmed", url: "purchases/comfirmed" },
        { name: "Cancelled", url: "purchases/cancelled" },
        { name: "Fake", url: "purchases/fake" },
      ],
    },
    {
      name: "Sales",
      url: "#",
      icon: faBoxesAlt,
      subLinks: [
        { name: "All", url: "sales/all" },
        { name: "Uncredentialed", url: "sales/uncredentialed" },
        { name: "Credentialed", url: "sales/credentialed" },
        { name: "Confirmed", url: "sales/confirmed" },
        { name: "Completed", url: "sales/completed" },
        { name: "Cancelled", url: "sales/cancelled" },
        { name: "Fake", url: "sales/fake" },
      ],
    },
    {
      name: "Transactions",
      url: "#",
      icon: faMoneyBill,
      subLinks: [
        { name: "All", url: "transactions/all" },
        { name: "Credit", url: "transactions/credit" },
        { name: "Debit", url: "transactions/debit" },
      ],
    },
    {
      name: "List",
      url: "#",
      icon: faPlus,
      subLinks: [
        { name: "New", url: "list/new" },
        { name: "Featured", url: "list/featured" },
      ],
    },

    {
      name: "Profile",
      url: "profile",
      icon: faUser,
    },
    {
      name: "Wallet",
      url: "wallet",
      icon: faWallet,
    },

    {
      name: "Settings",
      url: "/user/my-dashboard/settings",
      icon: faGears,
    },
    {
      name: "Site",
      url: "/",
      icon: faHome,
    },
  ];

  const navLinks = [{ name: "Me", url: "/user/my-profile", icon: faUser }];
  return (
    <Dashboard
      sidebarLinks={links}
      navBarTitle={"My Dashboard"}
      profileTitle={"User"}
      navLinks={navLinks}
      cartIcon={<Cart />}
      notificationCount={notificationsCount}
    >
      {isLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-950/70 z-50">
          <Spinner />
        </div>
      )}
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="grid place-items-center min-h-[50vh]">
            <Spinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </Dashboard>
  );
};

export default userDashboard;
